import { useServiceFactory } from '@euler/services/factory';
import { Refreshing, useRefreshing } from './useRefreshing';
import { WorkshopJob, workshopJobFromItem } from './workshopJobFromItem';

/** The construction jobs still open in the store, grouped by car. */
export function useWorkshopJobs(): Refreshing<WorkshopJob[]> {
  const { taskService } = useServiceFactory();
  return useRefreshing(
    'jobs',
    async () => (await taskService.listWorkshopJobs()).map(workshopJobFromItem),
    [taskService],
  );
}
